import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import MetaInfo from '@common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.APPLICATION_MODERNIZATION)


 const DELIVERABLES = [
  {title: 'Lower Technical Debt',},
  {title: 'Better Performance & Reliability',},
  {title: 'Stronger Security',},
  {title: 'Faster Innovation',},
  {title: 'Greater Scalability',},
  {title: 'Extended Application Life',},
]

const MODERNIZATION_GOAL = [
  {title: 'Enable AI Adoption',     desc: 'Legacy applications may not be structured to integrate modern AI capabilities. Modernize application architecture, APIs, data access, and workflows to create a stronger foundation for Generative AI, intelligent automation, analytics, and AI-powered features.' },
  {  title: 'Improve User Experience',      desc: 'Refresh outdated interfaces and workflows with modern, responsive, accessible, and user-friendly digital experiences.' },
  { title: 'Improve Application Performance',           desc: 'Identify performance bottlenecks across application code, databases, APIs, infrastructure, and integrations to create faster and more reliable applications.' },
  { title: 'Modernize the Technology Stack',  desc: 'Upgrade outdated frameworks, programming languages, databases, libraries, and development environments to more sustainable and supportable technologies.' },
  { title: 'Transform Legacy Architecture',  desc: 'Move from tightly coupled or monolithic systems toward modular, service-oriented, API-driven, or cloud-ready architectures where appropriate.' },
  { title: 'Strengthen Security',  desc: 'Address outdated security practices, vulnerable dependencies, access-control issues, and architectural weaknesses while bringing applications in line with modern security expectations.' },
  
]

const OUR_MODERNIZATION = [
  { title: 'Legacy Application Assessment', desc: 'Understand application architecture, technology, dependencies, risks, and modernization opportunities.' },
  { title: 'Application Re-engineering',            desc: 'Restructure and rebuild critical components using modern engineering practices.' },
  { title: 'Architecture Modernization',   desc: 'Transition rigid architectures toward modular, scalable, API-driven designs.' },
  { title: 'Technology & Framework Modernization ', desc: 'Upgrade outdated technology stacks and development frameworks.' },
  { title: 'Database Modernization',    desc: 'Improve database architecture, performance, compatibility, and integration.' },
  { title: 'Cloud Modernization ',    desc: 'Prepare applications for cloud migration, cloud-native architecture, or hybrid environments.' },
  { title: 'API Enablement ',    desc: 'Expose legacy functionality through secure and scalable APIs for modern applications and integrations.' },
  { title: 'UI & UX Modernization',    desc: 'Transform outdated interfaces into modern, responsive digital experiences.' },
  { title: 'Application Integration',    desc: 'Connect legacy systems with modern applications, platforms, APIs, and third-party services.' },
]
export default function ApplicationModernization() {
  

  return (
    <> 
    {/* <MetaInfo
        title="Application Modernization | CruxBytes"
        description="Modernize legacy applications for better performance, security and scalability with application modernization services from CruxBytes."
        keywords="application modernization, legacy application modernization, legacy system migration, application re-engineering, API enablement, cloud modernization, CruxBytes"
      /> */}
       <MetaInfo
      title={label}
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- Software Development -</div> */}
             <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* Application Modernization */}
              {label}
             </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Modernize legacy applications for improved performance and scalability. */}
             {pageDesc}
             </p>
             
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>

          <section
      id="strengths"
      className="about-us-section section-py  bg-linear-gradient-light "
      aria-labelledby="strengths-heading"
      data-aos="fade-up"
    >   <div className='container'> 
    
      <div className="sc-tm-row pt-4">

      <div className="sc-tm-content" data-aos="fade-left">
       
    <p>Legacy applications often continue to support critical business processes, but outdated technology, rigid architectures, security limitations, and increasing maintenance costs can hold businesses back.</p>
    <p>Our approach focuses on understanding what should be retained, improved, re-engineered, integrated, or replaced. This allows organizations to modernize strategically while reducing disruption to ongoing operations.</p>
      </div>
      <div  data-aos="fade-right">
        <div className="contact-form-wrap">
          <p className='text-bold'>Application modernization does not always mean replacing an entire system.</p>
          <p>CruxBytes helps organizations modernize existing applications while protecting the business logic, data, and investments that already work. We assess the existing technology landscape, identify modernization opportunities, and create a practical path toward modern, secure, scalable, and maintainable applications.</p>
        </div>
      </div>

    </div>
    <div className="section-header pt-4 mt-2 mb-4" data-aos="fade-up">
              <h3 id="cto-capabilities-heading">What Modernization Can Deliver</h3>
              
            </div>
                  <ul className="deliverables-grid--centered deliverables-grid--cols-4 flip-grid">
          {DELIVERABLES.map((item, i) => (
            <li
              key={item.title}
              className="flip-card"
              tabIndex={0}
              data-aos="fade-up"
              data-aos-delay={(i % 3) * 70}
            >
              <div className="flip-card__inner">
                <div className="flip-card__face">
                 
                  <div className="flip-card__title">{item.title}</div>
                </div>
                <div className="flip-card__face flip-card__face--back">
                 
                   <div className="flip-card__title">{item.title}</div>
                </div>
              </div>
            </li>
          ))}
        </ul>
    </div>  
    </section>

   {/* section 2 */}
    <section className="bgs-section--tint section-py" ria-labelledby="cto-benefit-heading" >
      <div className="container">
          <div className="section-header" data-aos="fade-up">
              <h2 id="cto-benefit-heading">Application Modernization Use Cases</h2>
             <p>The goal of modernization is not simply to replace old technology with new technology. It is to create a better technology foundation while preserving the business capabilities that matter.</p>
            </div>

       
             <div className="wcs-grid wcs-grid--3">
          {MODERNIZATION_GOAL.map((card, i) => (
            <div
              key={card.title}
              className="wcs-card-offer"
              data-aos="fade-up"
              data-aos-delay={(i % 3) * 80}
            >
              
              <h3 className="wcs-offer-title">{card.title}</h3>
              <p className="wcs-offer-desc">{card.desc}</p>
            </div>
          ))}
        </div>
        <p className="text-highlight pt-4" data-aos="fade-up" >
         Whether you need to modernize one critical application or transform a broader legacy technology landscape, CruxBytes can help create a structured path from legacy systems to modern, scalable digital platforms.
        </p>
        <div className="text-center pt-4">
          <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-left">
            Get a free assessment
          </Button>
        </div>
      </div>
    </section>
    {/* section 3 */}


   <section className="section-py" aria-labelledby="we-assess-heading">
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <h2 id="we-assess-heading">Our Application Modernization Capabilities</h2>
        </div>

      <div className="comparison-inner-table" role="table" aria-label="Comparison of other providers versus us" data-aos="fade-right">
       
          {OUR_MODERNIZATION.map(row => (
            <div className="comparison-inner-row" role="row" key={row.title}>
              <div className="comparison-inner-cell comparison-cell--title" role="cell">
                 <i class="fa-regular fa-star  card-title-icon" aria-hidden="true"></i>
                 
                 <span className="comparison-title">{row.title}</span>
              </div>
              <div className="comparison-inner-cell comparison-cell--ours" role="cell">
                {row.desc}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
         <TransformBanner />
         </main>
         </>
  )
}